import Mailcheck from 'mailcheck';

const domains = [
  'gmail.com',
  'googlemail.com',
  'gmail.co.uk',
  'hotmail.com',
  'hotmail.co.uk',
  'outlook.com',
  'msn.com',
  'yahoo.com',
  'yahoo.co.uk',
  'ymail.com',
  'btinternet.com',
  'btopenworld.com',
  'sky.com',
  'virginmedia.com',
  'blueyonder.co.uk',
  'ntlworld.com',
  'virgin.net',
  'talktalk.net',
  'protonmail.com',
  'icloud.com',
  'o2.pl',
  'aol.com',
  'mail.com'];

const topLevelDomains = ['com', 'net', 'org', 'co.uk'];

$(document).ready(() => {
  function runMailcheck(targetElement, e) {
    const $targetParent = $(targetElement).parents('.mailcheck-parent');
    const $suggestionTargetSelector = $(targetElement).data('suggestion');
    const $suggestionTarget = $targetParent.find($suggestionTargetSelector);
    const $emailFieldSelector = $(targetElement).data('suggestion-field');
    const $emailField = $targetParent.find($emailFieldSelector);
    const emailValue = $emailField.val();

    Mailcheck.run({
      email: emailValue,
      domains,
      topLevelDomains,
      suggested(suggestion) {
        // ensure submit button is enabled even when text field keyup is not triggered
        $($emailField[0].form).find(':submit').attr('disabled', false);

        const suggested = $('<a  tabindex="0" href="javascript:void(0)" >');
        suggested.text(suggestion.full);

        suggested.on('click', () => {
          $emailField.val(suggested.text());
          $suggestionTarget.text('').hide();
          $emailField.trigger('focus');
        });
        $($suggestionTarget).html('Did you mean: ')
          .append(suggested)
          .show();
      },
      empty() {
        $($suggestionTarget).text('');
      },
    });

    $('.btn-cancel').on('click', () => {
      $($suggestionTarget).text('');
    });

    if ($suggestionTarget.text().length !== 0) {
      e.preventDefault();
      e.stopPropagation();
      return false; // only prevent submission if there is a suggestion
    }
    return true;
  }

  $('[data-suggestion]').parents('form').one('submit', (e) => {
    runMailcheck($(e.target).find('[data-suggestion]')[0], e);
  });
});
